import { c as _c } from "react/compiler-runtime";
import { getOptionLabel } from "@/lib/measurement-calculations";
import { cx } from "@/lib/tailwind-utils";
import type { MeasurementField } from "@/types/measurement";
interface MeasurementValueChipsProps {
  values: string[];
  field: Pick<MeasurementField, "options">;
  variant?: "chips" | "inline";
  testId?: string;
  className?: string;
}
export function MeasurementValueChips(t0) {
  const $ = _c(17);
  const {
    values,
    field,
    variant: t1,
    testId,
    className
  } = t0;
  const variant = t1 === undefined ? "chips" : t1;
  if (values.length === 0) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== className || $[1] !== field || $[2] !== testId || $[3] !== values || $[4] !== variant) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t6;
      if ($[9] !== field) {
        t6 = v => getOptionLabel(field, v);
        $[9] = field;
        $[10] = t6;
      } else {
        t6 = $[10];
      }
      const labels = values.map(t6);
      if (variant === "inline") {
        t5 = <span data-testid={testId} className={className}>{labels.join(", ")}</span>;
        break bb0;
      }
      t2 = testId;
      if ($[11] !== className) {
        t3 = cx("inline-flex flex-wrap gap-1", className);
        $[11] = className;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      t4 = labels.map(_temp);
    }
    $[0] = className;
    $[1] = field;
    $[2] = testId;
    $[3] = values;
    $[4] = variant;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t6 = <span data-testid={t2} className={t3}>{t4}</span>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(label, i) {
  return <span key={i} className="rounded bg-background-secondary px-1.5 py-0.5 text-caption text-foreground-secondary">{label}</span>;
}